// src/modules/app-views/goodsReceipt/components/CardHeaderGoodsReceiptIssuerInfo.jsx
// *******************************************************************************
// CARD HEADER COLUMN 3: Issuer Name, CNPJ, State Registration
// *******************************************************************************
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import {
  ShopOutlined,
  FileProtectOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';
import { parseCnpjToDisplay } from 'utils/helpers';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderGoodsReceiptIssuerInfo = ({
  showItem1 = true,
  showItem2 = true,
  showItem3 = true,
  forceShow = false,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const issuer = record?.issuer || {};
  const issuerName = issuer?.tradeName || issuer?.name;
  const issuerCnpj = issuer?.cpfCnpj && parseCnpjToDisplay(issuer.cpfCnpj);
  const issuerIe = issuer?.stateRegistration || null;

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'issuerName',
      icon: <ShopOutlined />,
      label: (
        <span className="text-uppercase">
          {issuerName || <span className="text-muted opacity-0-6">{translateX('supplier')}</span>}
        </span>
      ),
      tooltipText: translateX('supplier'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showItem1,
    },
    {
      key: 'issuerCnpj',
      icon: <FileProtectOutlined />,
      label: issuerCnpj || <span className="text-muted opacity-0-6">{translateX('cnpj')}</span>,
      tooltipText: translateX('cnpj'),
      tooltipPlacement: 'right',
      onClick: issuerCnpj
        ? () => appService.handleCopyToClipboard(issuer.cpfCnpj, 'cnpj_copied')
        : null,
      hidden: !showItem2,
    },
    {
      key: 'issuerIe',
      icon: <SafetyCertificateOutlined />,
      label: issuerIe || (
        <span className="text-muted opacity-0-6">{translateX('state_registration')}</span>
      ),
      tooltipText: translateX('state_registration'),
      tooltipPlacement: 'right',
      onClick: issuerIe
        ? () => appService.handleCopyToClipboard(issuerIe, 'ie_copied')
        : null,
      hidden: !showItem3,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => (i?.label || forceShow) && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderGoodsReceiptIssuerInfo;
